import styled, { css } from 'styled-components';

export const Badge = styled.div`
    align-items: center;
    align-self: flex-start;
    background-color: var(--gray200);
    border-radius: 50%;
    color: var(--gray800);
    display: inline-flex;
    font-size: 16px;
    font-weight: 600;
    height: 32px;
    justify-content: center;
    margin-left: -1px;
    min-height: 32px;
    min-width: 32px;
    position: absolute;
    text-transform: uppercase;
    width: 32px;
`;

export const Container = styled.div`
    border-radius: 18px;
    background-color: var(--color-white);
    border: 1px solid var(--gray200);
    box-shadow: var(--shadow-2);
    color: var(--gray800);
    cursor: grab;
    display: inline-flex;
    line-height: 24px;
    max-width: 100%;
    min-height: 32px;
    min-width: 64px;
    outline: none;
    padding: 0px;

    -webkit-tap-highlight-color: transparent;

    img {
        margin: 0 4px;
        vertical-align: middle;
    }

    &:disabled {
        box-shadow: none;
        border: 1px solid var(--gray200);
        cursor: initial;
    }

    &:focus {
        box-shadow: var(--outline);
    }

    @-moz-document url-prefix() {
        & > div {
            overflow-x: auto;
            overflow-y: hidden;
        }
    }
`;

const Fade = styled.span`
    background-size: cover;
    min-height: calc(100% - 2px);
    position: absolute;
    top: 1px;
    width: 56px;

    pointer-events: none;
    box-sizing: border-box;
`;

export const Icon = styled.div`
    height: 18px;
    width: 18px;
`;

export const RightFade = styled(Fade)`
    border-radius: 0 16px 16px 0;
    right: 1px;
    background: transparent;

    ${(props) =>
        props.overflowing &&
        props.type === 'listed' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), white, white);
        `}

    ${(props) =>
        props.overflowing &&
        props.type === 'inserted' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(225, 240, 255, 0.5), var(--blue50), var(--blue50));
        `}

        ${(props) =>
        props.overflowing &&
        props.type === 'validated' &&
        props.validationType === 'missing' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(246, 246, 246, 0.5), var(--gray50), var(--gray50));
        `}

        ${(props) =>
        props.overflowing &&
        props.type === 'validated' &&
        props.validationType === 'warning' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(251, 244, 230, 0.5), var(--yellow50), var(--yellow50));
        `}


        ${(props) =>
        props.overflowing &&
        props.type === 'validated' &&
        props.validationType === 'success' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(239, 252, 224, 0.5), var(--green50), var(--green50));
        `}


        ${(props) =>
        props.overflowing &&
        props.type === 'validated' &&
        props.validationType === 'error' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(253, 239, 238, 0.5), var(--red50), var(--red50));
        `}
`;

export const Value = styled.div`
    padding: 4px 8px;
    font-size: 16px;
    min-height: 24px;
    letter-spacing: 0px;
    text-align: left;
    margin-left: 32px;
    max-height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100%;
`;

export const Wrapper = styled.div`
    position: relative;
    display: inline-flex;
    max-width: 100%;
    max-height: 100%;
    line-height: 32px;
    user-select: none;
`;
